import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n';
import { StyledPurchasesPage, PurchasesIcon } from './StyledComponents';
import innerAnalyticsVolia from 'helpers/innerAnalyticsVolia';
import Grid from 'components/Grid';
import ListItem from 'components/ListItem';
import { LIST_ITEMS_SIZE } from 'config';
import EmptyDataStub from 'components/EmptyDataStub';
import { useDispatch } from 'react-redux';
import { fetchPurchases, loadExtraPurchasedItems } from 'actions/purchases';

const ROW_SIZE = 4;

const PurchasesPage = (props) => {
  const { items } = props;
  const type = 'vod';
  const content = items[type];
  const dashboardName = 'PURCHASES';
  const dispatch = useDispatch();

  useEffect(() => {
    innerAnalyticsVolia.postEvent({
      eventGroup: `dashboard: ${dashboardName}`,
      eventName: 'open dashboard',
    });

    dispatch(fetchPurchases(type));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFocus = useCallback(
    (_item, index) => {
      const rows = content.data.length / ROW_SIZE;
      const currentRowIndex = Math.ceil(index / ROW_SIZE);
      const isRequiresExtraLoad = currentRowIndex >= rows - 1 - 1;
      if (isRequiresExtraLoad) dispatch(loadExtraPurchasedItems(type));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [content, loadExtraPurchasedItems],
  );

  return (
    <StyledPurchasesPage>
      {!content.isLoading && (
        <Grid
          items={content.data || []}
          rowSize={ROW_SIZE}
          showProgress={false}
          isEditable={false}
          gridId={`grid-purchases-${type}`}
          key={`grid-purchases-${type}`}
          title={i18n.t('purchases.title')}
          onFocus={onFocus}
          component={ListItem}
          itemSize={LIST_ITEMS_SIZE.LARGE}
          dashboardName={dashboardName}
          withoutContent={
            <EmptyDataStub
              emptyPlaceholder={i18n.t('purchases.emptyPlaceholder')}
              icon={<PurchasesIcon />}
              snLeft={'@MAIN_MENU'}
            />
          }
        />
      )}
    </StyledPurchasesPage>
  );
};

PurchasesPage.defaultProps = {
  items: {},
};

PurchasesPage.propTypes = {
  items: PropTypes.shape({
    vod: PropTypes.object.isRequired,
  }).isRequired,
  fetchPurchases: PropTypes.func.isRequired,
  loadExtraPurchasedItems: PropTypes.func.isRequired,
};

export default PurchasesPage;
